import {
  PrimitiveArraySerializer6xcmeltdozbx as PrimitiveArraySerializer,
  PrimitiveArrayBuilder1tzna3i4eqw54 as PrimitiveArrayBuilder,
} from './CollectionSerializers.mjs';
import { Companion_getInstance2xebdfu7t2o0y as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1wpgysz06u9ol as serializer_0,
  serializer3x9uckd1deom as serializer_1,
  serializerodflzzf6s3fp as serializer_2,
  serializer2lw83vwvpnyms as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializer3ikrxnm8b29d6 as serializer_5,
  serializer1tw0a8bv7lkga as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer1r0h5yakm679b as serializer_8,
  serializer36584sjyg5661 as serializer_9,
  serializer3u3hsxnenk49x as serializer_10,
} from '../builtins/BuiltinSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  charArray2ujmm1qusno00 as charArray,
  booleanArray2jdug9b51huk7 as booleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DoubleCompanionObject_instance1bwirhd8p0qhc as DoubleCompanionObject_instance,
  FloatCompanionObject_instance1gmrivpej6y77 as FloatCompanionObject_instance,
  IntCompanionObject_instance38ap4zil98hon as IntCompanionObject_instance,
  ShortCompanionObject_instancekdrujyym9g7v as ShortCompanionObject_instance,
  ByteCompanionObject_instance1i09zkznh3bs3 as ByteCompanionObject_instance,
  BooleanCompanionObject_instance1app94b8o3img as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instance1txg8t7ewhdy9 as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Companion_getInstance2ln0tj1crqgxz as Companion_getInstance_0,
  _ULong___init__impl__c78o9k4z3cjzifecv6 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzb2bbucljk081qt as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _ULongArray___get_size__impl__ju6dtr313kllzk1pm23 as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l3306egki9v2xvq as _ULongArray___init__impl__twm1l3,
  ULongArray__get_impl_pr71q91094qpdno4ge1 as ULongArray__get_impl_pr71q9,
  _ULongArray___get_storage__impl__28e64jn29edyvk0vk2 as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l311m1vqktvg80l as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvh3hfs4gnea82kx as ULongArray__set_impl_z19mvh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  Companion_getInstance1339zuieiizg3 as Companion_getInstance_1,
  _UInt___init__impl__l7qpdl2xbmh7to8lpd7 as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw2j5mttix8w0l0 as _UInt___get_data__impl__f0vqqw,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UIntArray___get_size__impl__r6l8ci2vbtulpoxx7m6 as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc67kyasm65n9ua as _UIntArray___init__impl__ghjpc6,
  UIntArray__get_impl_gp5kzan3fixfncx7fe as UIntArray__get_impl_gp5kza,
  _UIntArray___get_storage__impl__92a0v01hz5t8os1oam0 as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc61eq9zlp4q89r5 as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu213di7nm90jlnm as UIntArray__set_impl_7f2zu2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  Companion_getInstance3rx8u2n07bmtm as Companion_getInstance_2,
  _UShort___init__impl__jigrne3vu9egv7mch1k as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g0245313795p1x5hw5 as _UShort___get_data__impl__g0245,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UShortArray___get_size__impl__jqto1b3rfx6oix6j8vx as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26efzwhnyvfbg58m as _UShortArray___init__impl__9b26ef,
  UShortArray__get_impl_fnbhmx1exua9mtkbdj1 as UShortArray__get_impl_fnbhmx,
  _UShortArray___get_storage__impl__t2jpv53oc7c1c2s7ixe as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef2fr8vrbufr3j6 as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp179ynmfb9d38q as UShortArray__set_impl_6d8whp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  Companion_getInstance2utgi65n0nnqj as Companion_getInstance_3,
  _UByte___init__impl__g9hnc43bwrjlqz9k9id as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr23gcv767stjfh as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UByteArray___get_size__impl__h6pkdv2v04pt36vzsv4 as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1pmtxxp603qev as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv3v1a2l4kwelbl as UByteArray__get_impl_t5f3hv,
  _UByteArray___get_storage__impl__d4kctt79a8gj8q1jsz as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n1rg5c5y25iboz as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicnzooqhbuj870m as UByteArray__set_impl_jvcicn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  copyOf3rutauicler23 as copyOf_3,
  copyOf39s58md6y6rn6 as copyOf_4,
  copyOfwy6h3t5vzqpl as copyOf_5,
  copyOf37mht4mx7mjgh as copyOf_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CharArraySerializerClass;
function CharArraySerializer() {
  if (CharArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        CharArraySerializer_instance = null;
        super(serializer(Companion_getInstance()));
        CharArraySerializer_instance = this;
      }
      h20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.h20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      i20(_this__u8e3s4) {
        return new (CharArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.i20((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return charArray(0);
      }
      j20(decoder, index, builder, checkIndex) {
        builder.m20(decoder.r1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.j20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.j20(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      n20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.x1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.n20(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'CharArraySerializer', VOID, VOID, [KSerializer()]);
    CharArraySerializerClass = $;
  }
  return CharArraySerializerClass;
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new (CharArraySerializer())();
  return CharArraySerializer_instance;
}
var DoubleArraySerializerClass;
function DoubleArraySerializer() {
  if (DoubleArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        DoubleArraySerializer_instance = null;
        super(serializer_0(DoubleCompanionObject_instance));
        DoubleArraySerializer_instance = this;
      }
      q20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.q20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      r20(_this__u8e3s4) {
        return new (DoubleArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.r20((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return new Float64Array(0);
      }
      s20(decoder, index, builder, checkIndex) {
        builder.v20(decoder.q1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.s20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.s20(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      w20(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.w1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.w20(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'DoubleArraySerializer', VOID, VOID, [KSerializer()]);
    DoubleArraySerializerClass = $;
  }
  return DoubleArraySerializerClass;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new (DoubleArraySerializer())();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializerClass;
function FloatArraySerializer() {
  if (FloatArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        FloatArraySerializer_instance = null;
        super(serializer_1(FloatCompanionObject_instance));
        FloatArraySerializer_instance = this;
      }
      z20(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.z20((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      a21(_this__u8e3s4) {
        return new (FloatArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.a21((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return new Float32Array(0);
      }
      b21(decoder, index, builder, checkIndex) {
        builder.e21(decoder.p1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.b21(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.b21(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      f21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.v1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.f21(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'FloatArraySerializer', VOID, VOID, [KSerializer()]);
    FloatArraySerializerClass = $;
  }
  return FloatArraySerializerClass;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new (FloatArraySerializer())();
  return FloatArraySerializer_instance;
}
var LongArraySerializerClass;
function LongArraySerializer() {
  if (LongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        LongArraySerializer_instance = null;
        super(serializer_2(Companion_instance));
        LongArraySerializer_instance = this;
      }
      i21(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.i21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      j21(_this__u8e3s4) {
        return new (LongArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.j21((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return new BigInt64Array(0);
      }
      k21(decoder, index, builder, checkIndex) {
        builder.n21(decoder.o1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.k21(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.k21(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      o21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.u1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.o21(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'LongArraySerializer', VOID, VOID, [KSerializer()]);
    LongArraySerializerClass = $;
  }
  return LongArraySerializerClass;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new (LongArraySerializer())();
  return LongArraySerializer_instance;
}
var ULongArraySerializerClass;
function ULongArraySerializer() {
  if (ULongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ULongArraySerializer_instance = null;
        super(serializer_3(Companion_getInstance_0()));
        ULongArraySerializer_instance = this;
      }
      r21(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
      }
      w1v(_this__u8e3s4) {
        return this.r21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.dv_1 : THROW_CCE());
      }
      s21(_this__u8e3s4) {
        return new (ULongArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.s21(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.dv_1 : THROW_CCE());
      }
      t21() {
        return _ULongArray___init__impl__twm1l3(0);
      }
      h1x() {
        return new (ULongArray())(this.t21());
      }
      u21(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.t1r(this.y1w_1, index).z1q();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.x21(tmp$ret$0);
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.u21(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.u21(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      y21(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.z1s(this.y1w_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.j1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.y21(encoder, content instanceof ULongArray() ? content.dv_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ULongArraySerializer', VOID, VOID, [KSerializer()]);
    ULongArraySerializerClass = $;
  }
  return ULongArraySerializerClass;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new (ULongArraySerializer())();
  return ULongArraySerializer_instance;
}
var IntArraySerializerClass;
function IntArraySerializer() {
  if (IntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        IntArraySerializer_instance = null;
        super(serializer_4(IntCompanionObject_instance));
        IntArraySerializer_instance = this;
      }
      b22(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.b22((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      c22(_this__u8e3s4) {
        return new (IntArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.c22((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return new Int32Array(0);
      }
      d22(decoder, index, builder, checkIndex) {
        builder.g22(decoder.n1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.d22(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.d22(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      h22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.t1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.h22(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'IntArraySerializer', VOID, VOID, [KSerializer()]);
    IntArraySerializerClass = $;
  }
  return IntArraySerializerClass;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new (IntArraySerializer())();
  return IntArraySerializer_instance;
}
var UIntArraySerializerClass;
function UIntArraySerializer() {
  if (UIntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UIntArraySerializer_instance = null;
        super(serializer_5(Companion_getInstance_1()));
        UIntArraySerializer_instance = this;
      }
      k22(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
      }
      w1v(_this__u8e3s4) {
        return this.k22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.su_1 : THROW_CCE());
      }
      l22(_this__u8e3s4) {
        return new (UIntArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.l22(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.su_1 : THROW_CCE());
      }
      m22() {
        return _UIntArray___init__impl__ghjpc6(0);
      }
      h1x() {
        return new (UIntArray())(this.m22());
      }
      n22(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.t1r(this.y1w_1, index).y1q();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.q22(tmp$ret$0);
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.n22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.n22(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      r22(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.z1s(this.y1w_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.i1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.r22(encoder, content instanceof UIntArray() ? content.su_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UIntArraySerializer', VOID, VOID, [KSerializer()]);
    UIntArraySerializerClass = $;
  }
  return UIntArraySerializerClass;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new (UIntArraySerializer())();
  return UIntArraySerializer_instance;
}
var ShortArraySerializerClass;
function ShortArraySerializer() {
  if (ShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ShortArraySerializer_instance = null;
        super(serializer_6(ShortCompanionObject_instance));
        ShortArraySerializer_instance = this;
      }
      u22(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.u22((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      v22(_this__u8e3s4) {
        return new (ShortArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.v22((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return new Int16Array(0);
      }
      w22(decoder, index, builder, checkIndex) {
        builder.z22(decoder.m1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.w22(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.w22(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      a23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.s1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.a23(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ShortArraySerializer', VOID, VOID, [KSerializer()]);
    ShortArraySerializerClass = $;
  }
  return ShortArraySerializerClass;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new (ShortArraySerializer())();
  return ShortArraySerializer_instance;
}
var UShortArraySerializerClass;
function UShortArraySerializer() {
  if (UShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UShortArraySerializer_instance = null;
        super(serializer_7(Companion_getInstance_2()));
        UShortArraySerializer_instance = this;
      }
      d23(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
      }
      w1v(_this__u8e3s4) {
        return this.d23(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.ov_1 : THROW_CCE());
      }
      e23(_this__u8e3s4) {
        return new (UShortArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.e23(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.ov_1 : THROW_CCE());
      }
      f23() {
        return _UShortArray___init__impl__9b26ef(0);
      }
      h1x() {
        return new (UShortArray())(this.f23());
      }
      g23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.t1r(this.y1w_1, index).x1q();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.j23(tmp$ret$0);
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.g23(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.g23(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      k23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.z1s(this.y1w_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.h1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.k23(encoder, content instanceof UShortArray() ? content.ov_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UShortArraySerializer', VOID, VOID, [KSerializer()]);
    UShortArraySerializerClass = $;
  }
  return UShortArraySerializerClass;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new (UShortArraySerializer())();
  return UShortArraySerializer_instance;
}
var ByteArraySerializerClass;
function ByteArraySerializer() {
  if (ByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ByteArraySerializer_instance = null;
        super(serializer_8(ByteCompanionObject_instance));
        ByteArraySerializer_instance = this;
      }
      n23(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.n23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      o23(_this__u8e3s4) {
        return new (ByteArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.o23((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return new Int8Array(0);
      }
      p23(decoder, index, builder, checkIndex) {
        builder.s23(decoder.l1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.p23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.p23(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      t23(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.r1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.t23(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ByteArraySerializer', VOID, VOID, [KSerializer()]);
    ByteArraySerializerClass = $;
  }
  return ByteArraySerializerClass;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new (ByteArraySerializer())();
  return ByteArraySerializer_instance;
}
var UByteArraySerializerClass;
function UByteArraySerializer() {
  if (UByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UByteArraySerializer_instance = null;
        super(serializer_9(Companion_getInstance_3()));
        UByteArraySerializer_instance = this;
      }
      w23(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
      }
      w1v(_this__u8e3s4) {
        return this.w23(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.hu_1 : THROW_CCE());
      }
      x23(_this__u8e3s4) {
        return new (UByteArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.x23(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.hu_1 : THROW_CCE());
      }
      y23() {
        return _UByteArray___init__impl__ip4y9n(0);
      }
      h1x() {
        return new (UByteArray())(this.y23());
      }
      z23(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.t1r(this.y1w_1, index).w1q();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.c24(tmp$ret$0);
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.z23(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.z23(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      d24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.z1s(this.y1w_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.g1s(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.d24(encoder, content instanceof UByteArray() ? content.hu_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UByteArraySerializer', VOID, VOID, [KSerializer()]);
    UByteArraySerializerClass = $;
  }
  return UByteArraySerializerClass;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new (UByteArraySerializer())();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializerClass;
function BooleanArraySerializer() {
  if (BooleanArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        BooleanArraySerializer_instance = null;
        super(serializer_10(BooleanCompanionObject_instance));
        BooleanArraySerializer_instance = this;
      }
      g24(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      w1v(_this__u8e3s4) {
        return this.g24((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h24(_this__u8e3s4) {
        return new (BooleanArrayBuilder())(_this__u8e3s4);
      }
      r1u(_this__u8e3s4) {
        return this.h24((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      h1x() {
        return booleanArray(0);
      }
      i24(decoder, index, builder, checkIndex) {
        builder.l24(decoder.k1r(this.y1w_1, index));
      }
      c1v(decoder, index, builder, checkIndex) {
        return this.i24(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      i1x(decoder, index, builder, checkIndex) {
        return this.i24(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      m24(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.q1s(this.y1w_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      j1x(encoder, content, size) {
        return this.m24(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'BooleanArraySerializer', VOID, VOID, [KSerializer()]);
    BooleanArraySerializerClass = $;
  }
  return BooleanArraySerializerClass;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new (BooleanArraySerializer())();
  return BooleanArraySerializer_instance;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.k20_1 = bufferWithData;
        this.l20_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.l20_1;
      }
      e1x(requiredCapacity) {
        if (this.k20_1.length < requiredCapacity)
          this.k20_1 = copyOf(this.k20_1, coerceAtLeast(requiredCapacity, imul(this.k20_1.length, 2)));
      }
      m20(c) {
        this.l1x();
        var tmp = this.k20_1;
        var _unary__edvuaz = this.l20_1;
        this.l20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf(this.k20_1, this.l20_1);
      }
    }
    initMetadataForClass($, 'CharArrayBuilder');
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
var DoubleArrayBuilderClass;
function DoubleArrayBuilder() {
  if (DoubleArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.t20_1 = bufferWithData;
        this.u20_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.u20_1;
      }
      e1x(requiredCapacity) {
        if (this.t20_1.length < requiredCapacity)
          this.t20_1 = copyOf_0(this.t20_1, coerceAtLeast(requiredCapacity, imul(this.t20_1.length, 2)));
      }
      v20(c) {
        this.l1x();
        var tmp = this.t20_1;
        var _unary__edvuaz = this.u20_1;
        this.u20_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_0(this.t20_1, this.u20_1);
      }
    }
    initMetadataForClass($, 'DoubleArrayBuilder');
    DoubleArrayBuilderClass = $;
  }
  return DoubleArrayBuilderClass;
}
var FloatArrayBuilderClass;
function FloatArrayBuilder() {
  if (FloatArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.c21_1 = bufferWithData;
        this.d21_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.d21_1;
      }
      e1x(requiredCapacity) {
        if (this.c21_1.length < requiredCapacity)
          this.c21_1 = copyOf_1(this.c21_1, coerceAtLeast(requiredCapacity, imul(this.c21_1.length, 2)));
      }
      e21(c) {
        this.l1x();
        var tmp = this.c21_1;
        var _unary__edvuaz = this.d21_1;
        this.d21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_1(this.c21_1, this.d21_1);
      }
    }
    initMetadataForClass($, 'FloatArrayBuilder');
    FloatArrayBuilderClass = $;
  }
  return FloatArrayBuilderClass;
}
var LongArrayBuilderClass;
function LongArrayBuilder() {
  if (LongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.l21_1 = bufferWithData;
        this.m21_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.m21_1;
      }
      e1x(requiredCapacity) {
        if (this.l21_1.length < requiredCapacity)
          this.l21_1 = copyOf_2(this.l21_1, coerceAtLeast(requiredCapacity, imul(this.l21_1.length, 2)));
      }
      n21(c) {
        this.l1x();
        var tmp = this.l21_1;
        var _unary__edvuaz = this.m21_1;
        this.m21_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_2(this.l21_1, this.m21_1);
      }
    }
    initMetadataForClass($, 'LongArrayBuilder');
    LongArrayBuilderClass = $;
  }
  return LongArrayBuilderClass;
}
var ULongArrayBuilderClass;
function ULongArrayBuilder() {
  if (ULongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.v21_1 = bufferWithData;
        this.w21_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
        this.e1x(10);
      }
      a1x() {
        return this.w21_1;
      }
      e1x(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.v21_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.v21_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.v21_1), 2));
          tmp.v21_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
        }
      }
      x21(c) {
        this.l1x();
        var tmp = this.v21_1;
        var _unary__edvuaz = this.w21_1;
        this.w21_1 = _unary__edvuaz + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
      }
      n24() {
        var tmp0 = this.v21_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.w21_1;
        return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
      }
      c1x() {
        return new (ULongArray())(this.n24());
      }
    }
    initMetadataForClass($, 'ULongArrayBuilder');
    ULongArrayBuilderClass = $;
  }
  return ULongArrayBuilderClass;
}
var IntArrayBuilderClass;
function IntArrayBuilder() {
  if (IntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.e22_1 = bufferWithData;
        this.f22_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.f22_1;
      }
      e1x(requiredCapacity) {
        if (this.e22_1.length < requiredCapacity)
          this.e22_1 = copyOf_3(this.e22_1, coerceAtLeast(requiredCapacity, imul(this.e22_1.length, 2)));
      }
      g22(c) {
        this.l1x();
        var tmp = this.e22_1;
        var _unary__edvuaz = this.f22_1;
        this.f22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_3(this.e22_1, this.f22_1);
      }
    }
    initMetadataForClass($, 'IntArrayBuilder');
    IntArrayBuilderClass = $;
  }
  return IntArrayBuilderClass;
}
var UIntArrayBuilderClass;
function UIntArrayBuilder() {
  if (UIntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.o22_1 = bufferWithData;
        this.p22_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
        this.e1x(10);
      }
      a1x() {
        return this.p22_1;
      }
      e1x(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.o22_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.o22_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.o22_1), 2));
          tmp.o22_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
        }
      }
      q22(c) {
        this.l1x();
        var tmp = this.o22_1;
        var _unary__edvuaz = this.p22_1;
        this.p22_1 = _unary__edvuaz + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
      }
      o24() {
        var tmp0 = this.o22_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.p22_1;
        return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
      }
      c1x() {
        return new (UIntArray())(this.o24());
      }
    }
    initMetadataForClass($, 'UIntArrayBuilder');
    UIntArrayBuilderClass = $;
  }
  return UIntArrayBuilderClass;
}
var ShortArrayBuilderClass;
function ShortArrayBuilder() {
  if (ShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.x22_1 = bufferWithData;
        this.y22_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.y22_1;
      }
      e1x(requiredCapacity) {
        if (this.x22_1.length < requiredCapacity)
          this.x22_1 = copyOf_4(this.x22_1, coerceAtLeast(requiredCapacity, imul(this.x22_1.length, 2)));
      }
      z22(c) {
        this.l1x();
        var tmp = this.x22_1;
        var _unary__edvuaz = this.y22_1;
        this.y22_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_4(this.x22_1, this.y22_1);
      }
    }
    initMetadataForClass($, 'ShortArrayBuilder');
    ShortArrayBuilderClass = $;
  }
  return ShortArrayBuilderClass;
}
var UShortArrayBuilderClass;
function UShortArrayBuilder() {
  if (UShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.h23_1 = bufferWithData;
        this.i23_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
        this.e1x(10);
      }
      a1x() {
        return this.i23_1;
      }
      e1x(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.h23_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.h23_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.h23_1), 2));
          tmp.h23_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
        }
      }
      j23(c) {
        this.l1x();
        var tmp = this.h23_1;
        var _unary__edvuaz = this.i23_1;
        this.i23_1 = _unary__edvuaz + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
      }
      p24() {
        var tmp0 = this.h23_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.i23_1;
        return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
      }
      c1x() {
        return new (UShortArray())(this.p24());
      }
    }
    initMetadataForClass($, 'UShortArrayBuilder');
    UShortArrayBuilderClass = $;
  }
  return UShortArrayBuilderClass;
}
var ByteArrayBuilderClass;
function ByteArrayBuilder() {
  if (ByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.q23_1 = bufferWithData;
        this.r23_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.r23_1;
      }
      e1x(requiredCapacity) {
        if (this.q23_1.length < requiredCapacity)
          this.q23_1 = copyOf_5(this.q23_1, coerceAtLeast(requiredCapacity, imul(this.q23_1.length, 2)));
      }
      s23(c) {
        this.l1x();
        var tmp = this.q23_1;
        var _unary__edvuaz = this.r23_1;
        this.r23_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_5(this.q23_1, this.r23_1);
      }
    }
    initMetadataForClass($, 'ByteArrayBuilder');
    ByteArrayBuilderClass = $;
  }
  return ByteArrayBuilderClass;
}
var UByteArrayBuilderClass;
function UByteArrayBuilder() {
  if (UByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.a24_1 = bufferWithData;
        this.b24_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
        this.e1x(10);
      }
      a1x() {
        return this.b24_1;
      }
      e1x(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.a24_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.a24_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.a24_1), 2));
          tmp.a24_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
        }
      }
      c24(c) {
        this.l1x();
        var tmp = this.a24_1;
        var _unary__edvuaz = this.b24_1;
        this.b24_1 = _unary__edvuaz + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
      }
      q24() {
        var tmp0 = this.a24_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.b24_1;
        return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
      }
      c1x() {
        return new (UByteArray())(this.q24());
      }
    }
    initMetadataForClass($, 'UByteArrayBuilder');
    UByteArrayBuilderClass = $;
  }
  return UByteArrayBuilderClass;
}
var BooleanArrayBuilderClass;
function BooleanArrayBuilder() {
  if (BooleanArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.j24_1 = bufferWithData;
        this.k24_1 = bufferWithData.length;
        this.e1x(10);
      }
      a1x() {
        return this.k24_1;
      }
      e1x(requiredCapacity) {
        if (this.j24_1.length < requiredCapacity)
          this.j24_1 = copyOf_6(this.j24_1, coerceAtLeast(requiredCapacity, imul(this.j24_1.length, 2)));
      }
      l24(c) {
        this.l1x();
        var tmp = this.j24_1;
        var _unary__edvuaz = this.k24_1;
        this.k24_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      c1x() {
        return copyOf_6(this.j24_1, this.k24_1);
      }
    }
    initMetadataForClass($, 'BooleanArrayBuilder');
    BooleanArrayBuilderClass = $;
  }
  return BooleanArrayBuilderClass;
}
//region block: exports
export {
  BooleanArraySerializer_getInstance as BooleanArraySerializer_getInstance2n8qc5t6bzidf,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstance2b3lr11f78vwx,
  CharArraySerializer_getInstance as CharArraySerializer_getInstance349ncb5rlo1ht,
  DoubleArraySerializer_getInstance as DoubleArraySerializer_getInstance3a4lrva1sxxow,
  FloatArraySerializer_getInstance as FloatArraySerializer_getInstance3k2m7svdlnx7s,
  IntArraySerializer_getInstance as IntArraySerializer_getInstance1rr9hqd2i2l73,
  LongArraySerializer_getInstance as LongArraySerializer_getInstancem8l8n7vn8fdi,
  ShortArraySerializer_getInstance as ShortArraySerializer_getInstance29h5bb80p5isf,
  UByteArraySerializer_getInstance as UByteArraySerializer_getInstance30v15h7pvdc1u,
  UIntArraySerializer_getInstance as UIntArraySerializer_getInstance34p5jz9nln6hn,
  ULongArraySerializer_getInstance as ULongArraySerializer_getInstance1sitphir7efjg,
  UShortArraySerializer_getInstance as UShortArraySerializer_getInstance2ie8r4hvo8wlh,
};
//endregion

//# sourceMappingURL=PrimitiveArraysSerializers.mjs.map
